import PropTypes from 'prop-types';

export const headerSettingsShape = {
  imageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  imageLink: PropTypes.string,
  imageScale: PropTypes.number,
  imageAlign: PropTypes.oneOf(['left', 'center', 'right']),

  showSiteLinks: PropTypes.bool,

  link1Text: PropTypes.string,
  link1Url: PropTypes.string,

  link2Text: PropTypes.string,
  link2Url: PropTypes.string,

  link3Text: PropTypes.string,
  link3Url: PropTypes.string,

  link4Text: PropTypes.string,
  link4Url: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/js/widgets/Header/headerWidgetHelper.js